/**
 * I5 / R14 — waitlist strings (fr = source; en/ar typed against it).
 * Wired under `i5.waitlist`.
 */
import type { Catalog } from './fr';

const en: Catalog = {
  title: 'Waitlist',
  tab: 'Waitlist',
  template: 'Waitlist (double opt-in + referrals)',
  intro:
    'Signups go through double opt-in: people tick the consent box themselves, then confirm by email. Only confirmed signups receive the launch announcement.',
  notEnabled: 'This page is not a waitlist yet.',
  enable: 'Turn this page into a waitlist',
  enabled: 'Waitlist enabled.',
  readOnly: 'Read only: your role cannot change the waitlist.',
  unavailable: 'The waitlist is not available on this environment.',
  error: 'Something went wrong. Please retry.',
  config: {
    title: 'Settings',
    headline: 'Headline',
    description: 'Description',
    consentText: 'Exact consent checkbox wording (never pre-ticked)',
    submitLabel: 'Button label',
    collectName: 'Ask for the first name',
    referralK: 'Places gained per confirmed referral (k)',
    crmGroup: 'CRM group for export',
    save: 'Save',
    saved: 'Settings saved.',
  },
  stats: {
    title: 'Stats',
    total: 'Signups',
    pending: 'Awaiting confirmation',
    confirmed: 'Confirmed',
    referrals: 'Confirmed referrals',
    consent: 'Consents recorded',
    topReferrers: 'Top referrers',
    perDay: 'Signups per day',
    refresh: 'Refresh',
    empty: 'No signup yet.',
  },
  entries: {
    title: 'Signups',
    email: 'Email',
    status: 'Status',
    position: 'Position',
    referrals: 'Referrals',
    consent: 'Consent',
    remove: 'Erase',
    removeConfirm: 'Permanently erase this signup (right to erasure)?',
    masked: 'Addresses are masked for your role.',
    statuses: { pending: 'Pending', confirmed: 'Confirmed', unsubscribed: 'Unsubscribed' },
  },
  export: {
    title: 'Export to a CRM group',
    groupName: 'Group name',
    run: 'Export confirmed signups',
    done: '{{n}} contact(s) exported to “{{group}}” ({{skipped}} unconfirmed skipped).',
  },
  announce: {
    title: 'Launch announcement',
    hint: 'Sent only to confirmed signups, through the fail-closed CASL / Law 25 check.',
    subject: 'Subject',
    body: 'Message',
    preflight: 'Check recipients',
    allowed: '{{n}} allowed',
    blocked: '{{n}} blocked',
    reason: {
      consent_not_confirmed: 'consent not confirmed',
      compliance_check_unavailable: 'compliance check unavailable',
    },
    gateDown: 'The compliance check is unavailable: nothing can be sent.',
    send: 'Send the announcement to allowed recipients',
    sendConfirm: 'Send the announcement to {{n}} allowed recipient(s)?',
    sent: 'Announcement submitted: {{sent}} sent, {{blocked}} blocked.',
    preview: 'Preview',
  },
  public: {
    email: 'Your email',
    name: 'Your first name',
    join: 'Join the waitlist',
    joining: 'Joining…',
    consentRequired: 'Tick the consent box to continue.',
    invalidEmail: 'Enter a valid email address.',
    checkInbox: 'Almost there! Open the confirmation email we just sent and click the link to get your position.',
    referredBy: 'You were invited by someone on the list.',
    preview: 'Preview: signup is disabled',
    failed: 'Signup failed. Please retry.',
  },
  confirm: {
    title: 'Signup confirmation',
    working: 'Confirming…',
    confirmed: 'You are on the list!',
    position: 'Your position: #{{n}}',
    of: 'of {{n}} confirmed signup(s)',
    referrals: 'Confirmed referrals: {{n}}',
    boost: 'Every friend who confirms with your link moves you up {{k}} place(s).',
    share: 'Your referral link',
    copy: 'Copy',
    copied: 'Link copied.',
    invalid: 'This confirmation link is invalid.',
    used: 'This link was already used: your signup is confirmed.',
    expired: 'This link expired. Sign up again to get a new link.',
    missing: 'Incomplete link: the confirmation token is missing.',
    back: 'Back to the page',
  },
};

export default en;
